import React from "react";
import { Notification, NotificationEvents } from "@lib/types/Notification";
import CustomerPayBillRequest from "./CustomerPayBillRequest";
import ScannedTransactionFound from "./ScannedTransactionFound";
import CustomerTransactionRequest from "./CustomerTransactionRequest";
import UnknownEvent from "./UnknownEvent";
import CustomerManualTransactionRequest from "./CustomerManualTransactionRequest";
import ErrorEvent from "./ErrorEvent";

export type NotificationListItemProps = {
  notification: Notification;
};

const NotificationListItem: React.FC<NotificationListItemProps> = (props) => {
  switch (props?.notification?.event) {
    case NotificationEvents.CustomerPayBillRequest:
      return <CustomerPayBillRequest {...props} />;
    case NotificationEvents.ScannedTransactionFound:
      return <ScannedTransactionFound {...props} />;
    case NotificationEvents.CustomerTransactionRequest:
      return <CustomerTransactionRequest {...props} />;
    case NotificationEvents.CustomerManualTransactionRequest:
      return <CustomerManualTransactionRequest {...props} />;

    case NotificationEvents.Error:
      return <ErrorEvent {...props} />;

    default:
      return <UnknownEvent {...props} />;
  }
};

export default NotificationListItem;
